import classes from './Text.module.css';

const Text = (props) => {
    return <p className={classes.text}>{props.children}</p>
};

export default Text;